import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'
import { useI18n } from '../i18n'

export function ForgotPasswordPage() {
  const { t } = useI18n()
  const navigate = useNavigate()
  const resetPassword = useAuthStore((s) => s.resetPassword)
  const error = useAuthStore((s) => s.error)

  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const ok = await resetPassword(email)
    if (ok) setSent(true)
  }

  return (
    <div className="flex min-h-full items-center justify-center px-4">
      <div className="w-full max-w-md">
        <h1 className="mb-2 text-2xl font-bold">{t('auth.resetPassword')}</h1>
        <p className="mb-6 text-sm text-text-muted">{t('auth.resetPasswordDesc')}</p>

        {error && (
          <div className="mb-4 rounded-lg bg-error/10 p-3 text-sm text-error">
            {error}
          </div>
        )}

        {sent ? (
          <div className="flex flex-col gap-4">
            <div className="rounded-lg bg-success/10 p-4 text-sm text-success">
              {t('auth.resetLinkSent', { email })}
            </div>
            <button
              onClick={() => navigate('/login')}
              className="rounded-lg bg-primary py-3 font-medium text-white hover:bg-primary-dark transition-colors"
            >
              {t('auth.backToLogin')}
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="email"
              placeholder={t('auth.email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-lg border-2 border-surface-lighter bg-surface-light px-4 py-3 text-text outline-none transition-colors focus:border-primary"
            />
            <button
              type="submit"
              className="rounded-lg bg-primary py-3 font-medium text-white hover:bg-primary-dark transition-colors"
            >
              {t('auth.sendResetLink')}
            </button>
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="text-sm text-text-muted hover:text-primary transition-colors"
            >
              {t('auth.backToLogin')}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
